"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MangopayBaseAddress = exports.Address = exports.BaseAddress = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
let BaseAddress = class BaseAddress {
    addressLine1;
    addressLine2;
    city;
    region;
    postalCode;
};
exports.BaseAddress = BaseAddress;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(1, {
        message: "Address Line 1 should not be empty",
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BaseAddress.prototype, "addressLine1", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BaseAddress.prototype, "addressLine2", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(1, {
        message: "City should not be empty",
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BaseAddress.prototype, "city", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BaseAddress.prototype, "region", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MinLength)(1, {
        message: "Postal Code should not be empty",
    }),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BaseAddress.prototype, "postalCode", void 0);
exports.BaseAddress = BaseAddress = __decorate([
    (0, class_transformer_1.Exclude)()
], BaseAddress);
let Address = class Address extends BaseAddress {
    regionId;
    countryId;
};
exports.Address = Address;
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Address.prototype, "regionId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Address.prototype, "countryId", void 0);
exports.Address = Address = __decorate([
    (0, class_transformer_1.Exclude)()
], Address);
let MangopayBaseAddress = class MangopayBaseAddress extends BaseAddress {
    countryISOCode;
};
exports.MangopayBaseAddress = MangopayBaseAddress;
__decorate([
    (0, class_validator_1.ValidateIf)((address) => ["US", "CA", "MX"].includes(address.countryISOCode)),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MangopayBaseAddress.prototype, "region", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], MangopayBaseAddress.prototype, "countryISOCode", void 0);
exports.MangopayBaseAddress = MangopayBaseAddress = __decorate([
    (0, class_transformer_1.Exclude)()
], MangopayBaseAddress);
//# sourceMappingURL=Address.js.map